// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var TankService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function TankService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Upload file into tank
     *
     * @since 1.0.0
     *
     * @param
     */
    TankService.prototype.createDoc = function (data) {
        var _this = this;
        return this.apiService
            .apiCall("POST", "tank", data)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Search docs of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    TankService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var _this = this;
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService
            .apiCall("GET", "tank", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Upload file into tank
     *
     * @since 1.0.0
     *
     * @param
     */
    TankService.prototype.updateDoc = function (docId, data) {
        var _this = this;
        return this.apiService
            .apiCall("PUT", "tank/" + docId, data)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update doc status
     *
     * @since 1.0.0
     *
     * @param
     */
    TankService.prototype.updateDocStatus = function (docId, viewed) {
        var _this = this;
        return this.apiService
            .apiCall("PUT", "tank/" + docId + "/update-status", { viewed: viewed })
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Delete permanently a tank
     *
     * @since 1.0.0
     *
     * @param tankDocId ID of the tank document
     */
    TankService.prototype.delete = function (tankDocId) {
        return this.apiService.apiCall('DELETE', "tank/" + tankDocId);
    };
    TankService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TankService_Factory() { return new TankService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: TankService, providedIn: "root" });
    return TankService;
}());
export { TankService };
